import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

/**
 * Hook to invalidate SSO connections queries.
 * Use this after creating, updating, or deleting SSO connections.
 *
 * Both the list and the per-connection detail queries are invalidated, so a
 * detail page open in another tab picks up a name or domain edit.
 */
export const useInvalidateConnections = () => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await Promise.all([
      queryClient.invalidateQueries({
        queryKey: ["enterprises.connections"]
      }),
      queryClient.invalidateQueries({
        queryKey: ["enterprises.connection"]
      })
    ]);
  }, [queryClient]);
};
